import { CalendarClockIcon } from './CalendarClockIcon';

/**
 * author: Austin Andrews
 * id 921F6084-24E6-4D62-8BF9-9258D8FADE8E
 * name calendar-clock
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-clock.svg
 * tags
 * - Date / Time 
 */
export const EventClockIcon = CalendarClockIcon;
export default EventClockIcon